module.exports = __webpack_public_path__ + "media/images/yellow_circle_chipped-fc0db23749f4828c4808a7cb3733326f.png";